import './componenteTablaLight.css'
export default function EmpleadoAsignadoComponenteTablaLight({ stro }) {
    return (
        <th className='textoBodyTablaLight'>
            <div className="d-flex align-items-center gap-2">
                <div className={stro.empleadoAsignado ? "circleVioleta" : ""}></div>
                {stro.empleadoAsignado}
            </div>
        </th>
    );
}
